// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__t0Del","footer":"ModalInfo_footer__2s_kJ"};